import {useNavigationService, useResourcesToken, useTrackingServiceToken} from '@/di/di.root-container.hooks';
import {AnalyticsClickToPlayType} from '@/services/TrackingService/TrackingService.constants';

import {useParams} from 'react-router-dom';

import {REF_ID, clientRoutes} from '@/constants';
import {ButtonLink, ButtonLinkMods, ButtonLinkSize} from '@/ui/kit/ButtonLink/ButtonLink';

export function InviteCta(): JSX.Element {
  const {text} = useResourcesToken().content.InviteCta;
  const navigationService = useNavigationService();
  const trackingService = useTrackingServiceToken();

  const params = useParams();
  const {refId} = params;

  return (
    <ButtonLink
      mod={ButtonLinkMods.ButtonPrimary}
      size={ButtonLinkSize.L}
      onClick={() => {
        trackingService.trackClickToPlayButton(AnalyticsClickToPlayType.BringAFriend);
        navigationService.navigateTo(`${clientRoutes.AuthUser}?${REF_ID}=${refId}`);
      }}
    >
      {text}
    </ButtonLink>
  );
}
